import { PiniaSharedState } from 'pinia-shared-state'
import { defineNuxtPlugin } from '@nuxtjs/composition-api'

export default defineNuxtPlugin((context) => {
  context.$pinia.use(PiniaSharedState({
    enable: false,
  }))
})
